import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ADMIN_TOKEN_KEY = "mcs_admin_token";
export const PARTNER_TOKEN_KEY = "mcs_partner_token";

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Pick token based on the URL path so admin/partner contexts don't collide
http.interceptors.request.use((config) => {
  const url = config.url || "";
  let token = null;
  if (url.startsWith("/partners")) {
    token = localStorage.getItem(PARTNER_TOKEN_KEY);
  } else {
    token = localStorage.getItem(ADMIN_TOKEN_KEY);
  }
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Retry transient errors (502/503/504 + network errors) up to 2 times with
// linear backoff. Helps users avoid seeing AxiosError: Network Error during
// production cold-starts or brief proxy hiccups.
http.interceptors.response.use(
  (r) => r,
  async (error) => {
    const config = error.config || {};
    const status = error.response?.status;
    const isTransient =
      !error.response || status === 502 || status === 503 || status === 504;
    if (!isTransient || config.__retryCount >= 2) {
      return Promise.reject(error);
    }
    config.__retryCount = (config.__retryCount || 0) + 1;
    const wait = config.__retryCount * 1000; // 1s, then 2s
    await new Promise((resolve) => setTimeout(resolve, wait));
    return http(config);
  },
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Ocurrió un error. Intenta nuevamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export { API };
